import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import HeroSlider from './hero-slider'
import { useEffectX } from 'use-effect-x'
import axios from 'axios'
import { Loader } from 'rsuite'
import configData from './../config.json'
import { useTranslation } from 'react-i18next'
import ReactHtmlParser from 'react-html-parser'
import { HomePageImages } from './others/home-images'

import flyingImg from './../img/categories_dowels.png'


const PageHome = (props) => {

  const { t, i18n } = useTranslation()
  const lang = i18n.language

  const history = useHistory()

  const [ sliders, setSliders ] = useState(null)
  const [ categories, setCategries ] = useState(null)
  const [ pageData, setPageData ] = useState(null)

  useEffectX(
    ({changedItem: [pageDataObj]}) => {
      if (pageDataObj.isFirstRun) {
        axios.get(`${configData['REST_URL']}/wp/v2/pages?slug=home`)
          .then(data => setPageData(data.data[0])) 
      }
    }, [pageData]
  )

  useEffectX(
    ({changedItem: [slidersObj]}) => {
      if (slidersObj.isFirstRun) {
        axios.get(`${configData['REST_URL']}/acf/v3/sliders`)
          .then(data => setSliders(data.data))
      }
    }, [sliders]
  )
  
  useEffectX(
    ({changedItem: [categoriesObj]}) => {
      if (categoriesObj.isFirstRun) {
        axios.get(`${configData['REST_URL']}/wp/v2/category`)
          .then((data => setCategries(data.data)))
      }
    }, [categories]
  )

  // handle scroll to about benox
  useEffect(() => {
    if (props?.location?.state?.aboutBenox) {
      aboutBenoxRef.current.scrollIntoView({ behavior: 'smooth' })   
    }  
  })

  const aboutBenoxRef = useRef()

  const showProducts = () => {
    history.push('/products')
  }

  const handleCategory = ( cat ) => {
    history.push(`/products?cat=${cat}`)
  }  

  const renderContent = () => {
    const content = ReactHtmlParser(pageData.content.rendered)
    const translatedContent = content.filter(el => {
      return el.props.id === lang
    })[0]
    return translatedContent
  }

  return (
    <div className="page page-home">
      <div className="hero">
        {sliders === null ? (
            <Loader 
            vertical
            center
            inverse
            size="lg" 
            /> 
        ) : (
          <HeroSlider
            slides={sliders}
          />          
        )}
      </div>
      <div className="categories">
        <div className="content">
          <div className="main">
            <div className="cat-img">
              <img src={flyingImg} className="flying-img" alt="" />
            </div>            
            <div className="cat-menu">
              <div className="cat-menu-wrapper">
                {pageData === null ? (
                  <div style={{height: '250px'}}>
                    <Loader vertical center size="lg"/> 
                  </div>
                ) : (
                  <>
                    {categories?.slice(0,4).map(cat => (
                      <div className="cat-menu-item" key={cat.id} onClick={() => handleCategory(cat.id)}>
                        <div className="cat-menu-item-name">{cat.acf.names[`name_${lang}`]}</div>
                        <div className="cat-menu-item-sketch">
                          <img src={cat.acf.sketch} alt={cat.acf.names[`name_${lang}`]}/>
                        </div>
                      </div>
                    ))}
                    <div className="cat-menu-item extra" onClick={showProducts}>
                      <div className="cat-menu-item-name">
                        {t("and other fasteners")}
                      </div>
                      <p>{t("including specialized electrical and sanitary fixings, pipe clamps or chemical anchors")}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="show-all" onClick={() => showProducts()}>
            <span className="label">{t("Check full offer")}</span>
          </div>
          <div className="gray-box"></div>
        </div>
      </div>
      <div className="page-content" ref={aboutBenoxRef}>
        {pageData && renderContent()}
        {pageData && HomePageImages()}
      </div>
    </div>
  )
}

export default PageHome